<template>
  <main>
    <div class="container">
      <div class="preloader" v-if="addPreloader">
        <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
      </div>
      <div class="main-wrapper">
        <form class="order-list" @submit.prevent="sendForm()">
          <h1 class="main-title">Проведенная отстройка</h1>
          <div class="order-items" v-if="!isCartEmpty">
            <!-- Cart item start -->
            <div
              class="order-item"
              v-for="(basketItem, index) in localCart"
              :key="index"
            >
              <div class="order-item__edit-btn" @click="edit(basketItem)"></div>
              <h4>{{ basketItem.productName }}</h4>
              <div class="heading" v-if="basketItem.offers.length != 0">
                <p class="left-col">Название</p>
                <p class="right-col">Кол-во</p>
              </div>
              <div
                v-for="(option, optionIndex) in basketItem.offers"
                :key="optionIndex"
                class="options"
              >
                <p class="left-col">{{ option.offerName }}</p>
                <p class="right-col">{{ option.quantity }}</p>
              </div>
              <p v-if="basketItem.comment != ''" class="comment-block">
                {{ basketItem.comment }}
              </p>
            </div>
            <!-- Cart item end -->
          </div>
          <div class="order-items" v-else style="margin-bottom: 30px">
            Товаров в корзине нет!
          </div>
          <a href="/control-catalog" class="backToCatalog"
            >Вернуться в каталог</a
          >
          <input id="send-form" type="submit" :value="buttonText" />
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: () => ({
    localCart: {},
    buttonText: "Подтвердить",
    addPreloader: false,
  }),
  methods: {
    sendForm() {
      if (!this.isCartEmpty) {
        this.addPreloader = true;
        let miniCart = this.$localStorageGet("miniCart");
        let companyID = this.$localStorageGet("currentClient");
        let data = {
          companyId: companyID,
          baskets: miniCart.baskets,
        };

        this.$store.dispatch("CONTROL_CREATE_ORDER", data).then((r) => {
          if (r.data.status == "success") {
            this.$makeToast(
              "Поздравляем!",
              "success",
              `Отстройка успешно сохранена!`
            );
            // this.$localStorageSet('miniCart', {});
            setTimeout(() => {
              this.$router.push("/manufacture-comment/"+r.data.data.id);
            }, 3000);
          }
        });
      }
    },
    edit(el) {
      this.$router.push(
        "/control-detail/" + el.collectionID + "/" + el.productId
      );
    },
  },
  created() {
    let miniCart = this.$localStorageGet("miniCart");
    this.localCart = miniCart.baskets;
    // Блокируем кнопку назад в телефоне
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event){
      history.pushState(null, document.title, location.href);
    });
  },
  computed: {
    isCartEmpty() {
      //Проверить пустая корзина или нет
      if (Object.keys(this.localCart).length == 0) {
        this.buttonText = "Выйти из магазина";
      } else {
        this.buttonText = "Завершить";
      }

      return Object.keys(this.localCart).length == 0 ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
#send-form {
  font-size: 16px;
}
.order-item__edit-btn {
  top: 10px;
  right: 15px;
}
.order-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 10px;
  h4 {
    font-size: 14px;
    max-width: 200px;
    text-align: center;
  }
}
.options {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 10px;
  flex-wrap: wrap;
  .left-col {
    width: 70%;
    font-size: 12px;
  }
  .right-col {
    width: 30%;
    text-align: center;
  }
}
.heading {
  width: 100%;
  display: flex;
  border: 1px solid #dcdcdc;
  margin-top: 10px;
  .left-col {
    width: 70%;
    font-size: 12px;
    text-align: center;
    font-weight: bold;
  }
  .right-col {
    width: 30%;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
  }
}
.comment-block {
  font-size: 12px;
  width: 100%;
  border: 1px solid #dcdcdc;
  padding: 5px;
  margin-top: 10px;
}
.order-items {
  width: 100%;
}
</style>